'use strict';

var React = require('react'),
    UserLink = require('../atoms/UserLink'),
    Link = require('../atoms/Link'),
    MetaList = require('../molecules/MetaList'),
    UserImage = require('../atoms/UserImage'),
    Link = require('../atoms/Link'),
    Icon = require('../atoms/Icon'),
    ServiceAccountStore = require('../stores/ServiceAccountStore'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    normalizeUrl = require('../utils/normalizeUrl'),
    getServiceAccountUrl = require('../utils/getServiceAccountUrl'),
    pluralize = require('../utils/pluralize'),
    SidebarActionCreators = require('../actions/SidebarActionCreators'),
    SidebarTypes = require('../constants/SidebarTypes'),
    UserStore = require('../stores/UserStore'),
    PropTypes = React.PropTypes;

require('./UserInfo.less');

var UserInfo = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin, createStoreMixin(ServiceAccountStore, UserStore)],

  propTypes: {
    user: React.PropTypes.object.isRequired,
    noLink: PropTypes.bool,
    noName: PropTypes.bool,
    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
    imageSize: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large', 'xlarge']),
    vertical: PropTypes.bool,
    showAbout: PropTypes.bool,
    showLocation: PropTypes.bool,
    showWebsite: PropTypes.bool,
    showAccounts: PropTypes.bool,
    showSubscribers: PropTypes.bool,
    showSubscriptions: PropTypes.bool
  },

  getDefaultProps() {
    return {
      size: 'medium',
      card: false,
      showAbout: false,
      showLocation: false,
      showWebsite: false,
      showAccounts: false,
      showSubscribers: false,
      showSubscriptions: false
    };
  },

  getStateFromStores(props) {
    return {
      accounts: props.showAccounts && ServiceAccountStore.getUserVisibleServiceAccounts(props.user.id)
    };
  },

  getCSSModifiers() {
    return [
      this.props.size,
      this.props.vertical && 'vertical',
      this.props.card && 'card'
    ];
  },

  componentWillReceiveProps(nextProps) {
    if (this.props.user !== nextProps.user) {
      this.setState(this.getStateFromStores(nextProps));
    }
  },

  render() {
    return (
      <div className={this.getClassName()}>
        {this.renderImage()}
        {this.renderBody()}
      </div>
    );
  },

  renderImage() {
    var image = (
      <UserImage user={this.props.user}
                 size={this.props.imageSize || this.props.size} />
    );

    if (this.props.noLink) {
      return image;
    }

    return (
      <UserLink user={this.props.user}
                className='UserInfo-avatar'
                showTitle>
        {image}
      </UserLink>
    );
  },

  renderBody() {
    var name = this.renderName(),
        user = this.props.user,
        children = this.props.children,
        isInNavBar = this.props.context === 'NavBar',
        showAdditional;

    showAdditional = this.props.showAbout ||
                     this.props.showLocation ||
                     this.props.showWebsite ||
                     this.props.showAccounts ||
                     this.props.showSubscribers ||
                     this.props.showSubscriptions ||
                     this.props.children;

    if (!name && !children) {
      return;
    }

    return (
      <div className='UserInfo-body'>

        <span>
          {isInNavBar &&
            'by '
          }
          {name}
        </span>

        {this.props.showAbout &&
          user.about &&
            <div className='UserInfo-about'>
              {user.about}
            </div>
        }

        {showAdditional &&
          <div className='UserInfo-additional'>
            {(this.props.showSubscribers || this.props.showSubscriptions) &&
              <MetaList>
                {this.props.showSubscribers && this.renderSubscribers()}
                {this.props.showSubscriptions && this.renderSubscriptions()}
              </MetaList>
            }

            {(this.props.showLocation || this.props.showWebsite) &&
              <div className='UserInfo-more'>
                <MetaList inline={true}>
                  {this.props.showWebsite && this.renderWebsite()}
                  {this.props.showLocation && this.renderLocation()}
                </MetaList>
              </div>
            }

            {this.props.showAccounts &&
              <div className='UserInfo-accounts'>
                {this.renderAccounts()}
              </div>
            }

            {children}

          </div>
        }
      </div>
    );
  },

  renderSubscribers() {
    var user = this.props.user,
        subscriberCount = user.subscriberCount;

    return (
      <Link className='UserInfo-followerCount'
            onClick={this.handleSubscribersClick}>
        <b>{subscriberCount}</b>
        {' '}
        {pluralize(subscriberCount, 'Follower', 'Followers')}
      </Link>
    );
  },

  renderSubscriptions() {
    var user = this.props.user,
        subscriptionCount = user.subscriptionCount;

    return (
      <Link className='UserInfo-followingCount'
            onClick={this.handleSubscriptionsClick}>
        <b>{subscriptionCount}</b>
        {' '}
        Following
      </Link>
    );
  },

  renderName() {
    if (this.props.noName) {
      return;
    }

    if (this.props.noLink) {
      return (
        <span className='UserInfo-name'>
          {this.props.user.name}
        </span>
      );
    }

    return (
      <UserLink user={this.props.user}
                className='UserInfo-name' />
    );
  },

  renderWebsite() {
    var user = this.props.user,
        website = user.website;

    if (!website) {
      return;
    }

    return (
      <Link href={normalizeUrl(website)}
            target='_blank'
            rel='me nofollow'
            underline='hover'>
        {normalizeUrl(website, true)}
      </Link>
    );
  },

  renderLocation() {
    var user = this.props.user,
        location = user.location;

    if (!location) {
      return;
    }

    return (
      <span>
        {user.location}
      </span>
    );
  },

  renderAccounts() {
    var accounts = this.state.accounts;
    if (!accounts.length) {
      return;
    }

    return (
      <MetaList separated={false}>
        {accounts.map(this.renderAccount)}
      </MetaList>
    );
  },

  renderAccount(account) {
    var serviceType = account.serviceType,
        url = getServiceAccountUrl(account);

    return (
      <Link key={serviceType}
            href={url}
            target='_blank'>
        <Icon name={serviceType.toLowerCase()}
              size='xsmall' />
      </Link>
    );
  },

  handleSubscriptionsClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.USER_SUBSCRIPTIONS, {
      userId: this.props.user.id
    });
  },

  handleSubscribersClick() {
    SidebarActionCreators.showSidebar(SidebarTypes.USER_SUBSCRIBERS, {
      userId: this.props.user.id
    });
  }
});

module.exports = UserInfo;



/** WEBPACK FOOTER **
 ** ./organisms/UserInfo.jsx
 **/